import { render, staticRenderFns } from "./managementServiceAndUser.vue?vue&type=template&id=0844f944&scoped=true&"
import script from "./managementServiceAndUser.vue?vue&type=script&lang=js&"
export * from "./managementServiceAndUser.vue?vue&type=script&lang=js&"
import style0 from "./managementServiceAndUser.vue?vue&type=style&index=0&id=0844f944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0844f944",
  null
  
)

export default component.exports